import axios from "axios";
import { UserStateInterface } from "../../../middleware/interfaces/user/user-state-interface";
import { ReportElementNoteUploadInterface } from "../../../middleware/interfaces/report/report-element-note-upload-interface";

export const ReportElementNoteUpload = {
  Upload: async (state: UserStateInterface) => {
    let serverResponse;
    if (state.data) {
      const reportElementNoteUploadData: ReportElementNoteUploadInterface =
        state.data;
      const url = "./php/report/report-element-note-uploader-proxy.php";
      await axios
        .post(url, reportElementNoteUploadData)
        .then((response) => {
          serverResponse = response.data;
        })
        .catch((error) => {
          serverResponse = {
            status: "error",
            header: "error",
            message: error.message,
          };
        });
    } else {
      serverResponse = {
        status: "error",
        header: "error",
        message: "Something went wrong! Please contact DigitalCharcoal",
      };
    }
    return serverResponse;
  },
};
